/**
 * Grid-related enumerations.
 * Defines display modes for the grid used by the mosaic template.
 */

enum GridDisplayMode {
  PHOTO = 'photo',
  SETTING = 'setting',
}

export { GridDisplayMode };
